
// tslint:disable:curly
import { Injectable } from '@angular/core';
import { DbRecordService } from './db-record.service';
import { RuntimeService } from './runtime.service';

@Injectable()
export class FileService {
  filesMap = new Map<string, Object[]>();
  private _uploadForms = new Set<string>();
  private _filterSwitch;

  constructor(
    private dbrs: DbRecordService,
    private runs: RuntimeService
  ) { }

  clear() {
    this.filesMap.clear();
  }

  newFromSaved(obj: Object, cancelUploadForm?: boolean) {
    let tpl = obj['filename'].split('/');
    let fn = tpl[tpl.length - 1];
    let p = tpl[tpl.length - 2];
    let i = fn.lastIndexOf('@');
    let parentId;


    if (i < 0)
      parentId = p;
    else {
      parentId = fn.slice(i + 1);
      i = parentId.lastIndexOf('.');
      if (i > 0)
        parentId = parentId.slice(0, i);
    }

    let ls = this.filesMap.get(parentId);
    if (!ls) {
      ls = [];
      this.filesMap.set(parentId, ls);
    }
    ls.push({
      project: p,
      path: `https://gae-test.ecomole.com/s/r/SearchManagerFiles/${p}/${fn}`,
      filename: fn,
      size: Math.round(obj['st_size'] / 100) / 10
    });
    if (cancelUploadForm)
      this._uploadForms.delete(`${p}::${parentId}`);
  }

  files(pid: string, projectShortcut: string) {
    return this.filesMap.get(pid) || [];
  }

  isUploadForm(uid: string) {
    return this._uploadForms.has(uid);
  }

  switchUploadForm(uid: string) {
    if (!this._uploadForms.delete(uid))
      this._uploadForms.add(uid);
  }

  isFilterOn(tag) {
    return this._filterSwitch === tag;
  }

  filterSwitch(tag) {
    if (this._filterSwitch === tag)
      this._filterSwitch = null;
    else
      this._filterSwitch = tag;
  }

  countRecords(isWith) {
    if (isWith) {
      return this.filesMap.size;
    } else {
      return this.dbrs.getTotalDbRecordsCount(
        this.runs.currentProject) - this.filesMap.size;
    }
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/file.service.ts